// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"fdc8bbff","572":"8bd52d49"}[chunkId] + ".chunk.js";
};